module.exports = __webpack_public_path__ + "static/media/installation concept.6e8c4998.png";